import { createContext, PropsWithChildren, useMemo, useState } from "react";
import { translations } from "./lib/translations";
import { Language, LanguageContextType } from "./types";

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider = ({ children }: PropsWithChildren) => {
  // default lenguage base on preferences
  const defaultLenguage = navigator.language.includes("es") ? "es" : "en";

  const [language, setLanguage] = useState<Language>(defaultLenguage);

  const t = (
    key: string,
    values?: {
      [key: string]: string | number;
    }
  ): string => {
    const keys = key.split(".");
    let text: any = translations[language];

    for (const k of keys) {
      text = text[k as keyof typeof text];
      if (!text) {
        return key; // Return the key if the translation is not found
      }
    }

    if (typeof text !== "string") {
      return key; // Return the key if the final value is not a string
    }

    if (!values) return text;

    return Object.entries(values).reduce((acc, [key, value]) => {
      return acc.replace(`{${key}}`, value.toString());
    }, text);
  };

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
